<!--
 * @Author: Gaho
 * @Date: 2024-03-14 10:45:55
 * @LastEditors: Merlin
 * @LastEditTime: 2025-06-04 10:53:29
 * @Description: 
-->
<template>
    <ClientOnly>    
        <div class="coinflip-bets">
            <div class="coinflip-bets-inner" ref="randomNumRef">
                <div
                    v-for="(v, k) in betHistory.filter(cur => !!cur)"
                    class="coinflip-bets-item mr-2"
                    :key="v.hash"
                    :class="{
                        'coinflip-bets-item-losing': !v.multi,
                        'fast': gameStore.coinflip.fast,
                    }"
                >
                    <div v-show="v.seed?.slice(0, 1) === '1'">
                        <img src="~/assets/webp/coin-head.webp" spinner-color="bg-[#283343]" />
                    </div>
                    <div v-show="v.seed?.slice(0, 1) === '0'">
                        <img src="~/assets/webp/coin-tail.webp" spinner-color="bg-[#283343]" />
                    </div>
                </div>
            </div>
        </div>
    </ClientOnly>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import useSettingsStore from '~/stores/settings';
export default defineComponent({
    name: 'resultHistory',
    props: {
        betHistory: {
            type: Object,
            default: () => [],
        },
    },
    data() {
        return {
            gameStore: useSettingsStore().game,
        };
    },
    mounted(){
        console.log('props.betHistory', this.betHistory)
    }
});
</script>

<style lang="scss" scoped>
.coinflip-bets {
    display: flex;
    flex: 1 1;
    height: 32px;
    overflow: hidden;
    position: relative;
    user-select: none;

    .coinflip-bets-inner {
        display: flex;
        right: 0;
        max-width: 100%;
        bottom: 0;
        position: absolute;
        top: 0;
        flex-direction: row-reverse;

        .coinflip-bets-item {
            animation-duration: 0.3s;
            animation-timing-function: ease-out;
            &:first-child {
                animation-name: horizont-1;
            }
            &:nth-child(2n) {
                animation-name: horizont-2;
            }
            &:nth-child(odd) {
                animation-name: horizont-3;
            }
            
            > div {
                width: 32px;
                height: 32px;
            }
        }

        @media (max-width: 1100px) {
            .coinflip-bets-item {
                margin-right: 5px;
                > div {
                    height: 24px;
                    width: 24px;
                }
            }
        }
        .coinflip-bets-item-losing {
            opacity: 0.25;
        }
        .fast {
            animation-duration: 0.1s;
        }
    }

    &::after {
        background: linear-gradient(90deg, #162c4a, rgba(22, 44, 74, 0));
        bottom: 0;
        content: '';
        display: block;
        left: -1px;
        position: absolute;
        top: 0;
        width: 25px;
    }
}

@media (max-width: 1100px) {
    .coinflip-bets {
        height: 24px;
    }
}
@keyframes horizont-1 {
    0% {
        transform: translateX(99.99%)
    }
}

@keyframes horizont-2 {
    0% {
        transform: translate(99.99%)
    }
}

@keyframes horizont-3 {
    0% {
        transform: translateX(99.99%)
    }
}
</style>